import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuVertical = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 7.6129C11.1056 7.6129 12 8.45685 12 9.5C12 10.5431 11.1056 11.3871 10 11.3871C8.89444 11.3871 8 10.5431 8 9.5C8 8.45685 8.89444 7.6129 10 7.6129ZM8 4.8871C8 5.93024 8.89444 6.77419 10 6.77419C11.1056 6.77419 12 5.93024 12 4.8871C12 3.84395 11.1056 3 10 3C8.89444 3 8 3.84395 8 4.8871ZM8 14.1129C8 15.156 8.89444 16 10 16C11.1056 16 12 15.156 12 14.1129C12 13.0698 11.1056 12.2258 10 12.2258C8.89444 12.2258 8 13.0698 8 14.1129Z",
		fill: "#0D2976"
	})
});
export default SvgMenuVertical;
